<div>

  <input #input
    [attr.title]="label"
    [type]="htmlInputType"
    [attr.name]="name"
    [attr.placeholder]="placeholder"
    [attr.autocomplete]="autocomplete"
    [readonly]="readonly"
    (blur)="formatValue()"
    [formControl]="control">

  <kal-icon *ngIf="shouldDisplayClearIcon"
            (click)="clearField()">
    clear
  </kal-icon>

  <kal-icon *ngIf="icon && !shouldDisplayClearIcon"
            (click)="customIconClicked($event)">
    {{ icon }}
  </kal-icon>

</div>

<ng-container *ngIf="limit">

  <div class="counter">
    {{ value?.length || 0}} / {{ limit }}
  </div>

</ng-container>
